import React, { useEffect } from 'react';
import { useOperatorTailContext } from 'src/contexts/operator-tail.context';
import { actionTypes } from 'src/ducks/operator-tail.duck';
import { getOperatorTailStatus } from 'src/selectors/operator-tail.selector';
import OperatorTailListView from './operator-tail-number-relationship-list.view';

const OperatorTailList: React.FC = () => {
  const { state, actions } = useOperatorTailContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <OperatorTailListView
      loading={
        getOperatorTailStatus(state, actionTypes.OPERATOR_TAIL_NUMBER_FETCH)
          .fetching
      }
      data={state.list}
    />
  );
};

export default OperatorTailList;
